import { bootstrap } from "./b2x-voca-loader";
bootstrap();
